import Pill from '@components/V3/Pill'

const UserMenuSkeleton = () => {
  return <Pill showCaret={false} className="h-12 min-w-12 w-fit animate-pulse"></Pill>
}

export default UserMenuSkeleton
